// extracted by mini-css-extract-plugin
export var category = "_kf-9";
export var categoryHeader = "_kf-e";
export var container = "_kf-0";
export var group = "_kf-a";
export var groupItems = "_kf-f";
export var groupSeparator = "_kf-j";
export var loading = "_kf-1";
export var noResults = "_kf-3";
export var placeholder = "_kf-2";
export var resultContent = "_kf-5";
export var resultIcon = "_kf-c";
export var resultItem = "_kf-g";
export var resultMeta = "_kf-8";
export var resultSubtitle = "_kf-7";
export var resultSuffix = "_kf-i";
export var resultTitle = "_kf-6";
export var resultsList = "_kf-4";
export var searchGroup = "_kf-d";
export var selected = "_kf-h";
export var subgroup = "_kf-b";